import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Rocket, ArrowRight } from "lucide-react";
import { useContentSnippets } from "@/hooks/useContentSnippets";

const Modul0Entry = () => {
  const { getSnippet, loading } = useContentSnippets();

  return (
    <section className="py-12 bg-gradient-to-r from-primary to-accent relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,hsl(var(--primary)/0.3),transparent_70%)]" />
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-4">
          <Rocket className="w-4 h-4 text-white" />
          <span className="text-sm font-semibold text-white">100% kostenfrei – kein Risiko</span>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3 drop-shadow-md">
          {loading
            ? "Erste Schritte: Starten Sie jetzt kostenfrei mit Modul 0"
            : getSnippet("home_modul0_entry_h2", "Erste Schritte: Starten Sie jetzt kostenfrei mit Modul 0")}
        </h2>
        <p className="text-white/85 text-lg mb-6 max-w-2xl mx-auto">
          5 interaktive Lektionen – vom Leitbild bis zur Roadmap. Keine Vorkenntnisse nötig.
        </p>

        <Link to="/modul-0">
          <Button
            size="lg"
            className="bg-white text-primary hover:bg-white/90 px-10 py-6 text-lg font-bold shadow-xl"
          >
            Gratis-Einstieg <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default Modul0Entry;
